module.exports = __webpack_public_path__ + "static/media/chevron-square-up.0e98ca46.svg";